import React from "react";
import {Col, Row} from "antd";

import BookingUpdateForm from "./BookingUpdateForm";
import BookingEligibleDrivers from "./BookingEligibleDrivers";
import BookingCostBreakDown from "../billings/CostBreakdown/BookingCostBreakdown";
import BookingContactInfo from "./BookingContactInfo";
import JourneyDetailsCard from "./JourneyDetailsCard";
import {BookingDetailsParams} from "../../types/bookingTypes";
import {useAppSelector} from "../../hooks/useStore";
import {selectHasStaffRole} from "../../store/slices/userSlice";

import {cardsGridColumn} from "../../assets/styles";

const BookingDetails = ({
                            bookingID,
                            bookingDetails,
                            bookingDeploymentDetails,
                            eligibleDrivers,
                            isEstimatedCost,
                            isCancelledBooking,
                        }: BookingDetailsParams) => {
    const isMCT = useAppSelector(state => selectHasStaffRole(state, ['member-care', 'developer']));
    const formattedCosts = bookingDetails.costs.map(cost => ({
        type: cost.type,
        amount: Number(cost.amount)
    }));

    const formattedTaxes = bookingDetails.taxes.map(tax => ({
        name: tax.name,
        amount: Number(tax.amount),
        percent: Number(tax.percent)
    }));

    let totalCost = bookingDetails.costs.reduce((total, cost) => {
        return total + parseFloat(cost.amount);
    }, 0);

    const totalTax = bookingDetails.taxes.reduce((total, tax) => {
        return total + parseFloat(tax.amount);
    }, 0);

    return (
        <Row gutter={16}>
            <Col {...cardsGridColumn}>
                <BookingUpdateForm
                    bookingID={bookingID}
                    bookingDetails={bookingDetails}
                    bookingDeploymentDetails={bookingDeploymentDetails}
                    isEstimatedCost={isEstimatedCost}
                    isCancelledBooking={isCancelledBooking}
                    totalCost={totalCost}
                />
            </Col>
            <Col {...cardsGridColumn}>
                <JourneyDetailsCard journeyID={bookingDetails.journey_id} />
                {
                    isMCT ?
                        <>
                            <BookingContactInfo bookingID={bookingID} />
                            <BookingEligibleDrivers eligibleDrivers={eligibleDrivers} />
                        </>
                        : null
                }
            </Col>
            <Col {...cardsGridColumn}>
                <BookingCostBreakDown
                    costs={formattedCosts}
                    totalCost={totalCost}
                    taxes={formattedTaxes}
                    totalTax={totalTax}
                    isEstimatedCost={isEstimatedCost}
                    transactionsTable={false}
                />
            </Col>
        </Row>
    );
};

export default BookingDetails;
